
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

export const AddLeadType = ({ onClose, leadId, onSave,onRefresh }) => {
  console.log("Modal leadId:", leadId);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const apiUrl = process.env.REACT_APP_URL;
  const submit = async (data) => {
    try {
      const url = `${apiUrl}/lead/addLeadType/${leadId}`;

      const Token = localStorage.getItem("_ux98c_v1");
      const response = await fetch(url, {
        method: "POST",
        headers: {
          // "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          leadType: data.leadType,
        }),
        // body:{
        //   leadType: data.leadType,
        // }
      });


      const result = await response.json();

      if (result.status === "error") {
        throw new Error(result.message);
      }

      toast.success(result.message);
      onClose();
      if (onRefresh) {
        onRefresh();   
      }

    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div
      className="modal show d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">Lead Type</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <form onSubmit={handleSubmit(submit)}>

            <div className="modal-body">
              <label>Select Lead Type</label>

              <select
                className={`form-select ${errors.leadType ? "is-invalid" : ""}`}
                {...register("leadType", {
                  required: "Please select at least one lead type",
                })}
              >
                <option value="">Select</option>
                <option value="Hot">Hot</option>
                <option value="Cold">Cold</option>
                <option value="Warm">Warm</option>
              </select>

              {errors.leadType && (
                <div className="invalid-feedback">
                  {errors.leadType.message}
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button className="btn btn-primary" type="submit">
                Save
              </button>
            </div>

          </form>


        </div>
      </div>
    </div>
  );
};


